import { ApiHandler } from '../ApiHandler'

import { UpdateProfileRequest, User } from '@/shared/interfaces/User'

export abstract class UserApi {
    public static async get(): Promise<User> {
        return await ApiHandler.get('profile')
    }

    /**
    * Обновить данные профиля пользователя.
    */
    public static async updateProfile(args: UpdateProfileRequest): Promise<void> {
        await ApiHandler.post('profile', {
            name: args.firstname,
            surname: args.lastname,
            username: args.username,
            avatar: args.avatar,
            about_me: args.about,
            is_phone_visible: args.isPhoneVisible ? 1 : 0,
            is_notifications_active: args.isNotificationsEnabled ? 1 : 0,
        })
    }


}